import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { groupsRef } from './read';
import type { GroupFormValues } from '../../../../types/group';

/**
 * グループの名称・説明を更新する（#2804）
 */
export const updateGroup = async (
  companyId: string,
  groupId: string,
  values: GroupFormValues,
  updatedBy: string,
): Promise<void> => {
  await updateDoc(doc(groupsRef(companyId), groupId), {
    name: values.name,
    description: values.description ?? null,
    updated_at: serverTimestamp(),
    updated_by: updatedBy,
  });
};
